export const EVENTS = Object.freeze({
  PAGEVIEW: "PAGEVIEW",
  ARTICLE_EXTERNAL_CLICK: "ARTICLE_EXTERNAL_CLICK",
  NAV_EXTERNAL_CLICK: "NAV_EXTERNAL_CLICK",
  RESUME_PAGE_PDF_CLICK: "RESUME_PAGE_PDF_CLICK",
  RESUME_PAGE_LINKEDIN_CLICK: "RESUME_PAGE_LINKEDIN_CLICK",
  CONTENT_LINK_CLICK: "CONTENT_LINK_CLICK",
});
